import { ParsedUrlQuery } from 'querystring';

export function getIsSharedAccommodation(query: ParsedUrlQuery) {
    if (query['is_shared_accommodation']) {
        return query['is_shared_accommodation'];
    }

    return '';
}
